import { Dict } from "@verivest/shared-components";

export const validateAllAttributesExistInData = <T extends Dict>(
  attrList: Array<keyof T>,
  data: T,
) => {
  return attrList.reduce((acc, attribute) => {
    return acc && data[attribute] != null && data[attribute] !== "";
  }, true);
};
